// export const backendUrl = "http://localhost:5001/api/request/"
// export const imageUploadUrl = "http://localhost:5001/api/image/upload-image"
// export const imageDeleteUrl = "http://localhost:5001/api/image/delete-image"
export const backendUrl = "/api/request/"
export const imageUploadUrl = "/api/image/upload-image/"
export const imageDeleteUrl = "/api/image/delete-image/"
